import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import CaseStudy from "@/pages/CaseStudy";
import { DraftLayout } from "@/draft/DraftLayout";
import DraftHome from "@/draft/DraftHome";
import HowWeWork from "@/draft/HowWeWork";
import ServicePage from "@/draft/ServicePage";
import About from "@/draft/About";
import Apply from "@/draft/Apply";
import Book from "@/draft/Book";
import NotYet from "@/draft/NotYet";
import LegalPage from "@/draft/LegalPage";
import Contact from "@/draft/Contact";
import Sales from "@/sales/Sales";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const host = typeof window !== "undefined" ? window.location.hostname : "";
const isSalesHost = host.startsWith("sales.");

function App() {
  if (isSalesHost) {
    return (
      <div className="App font-sans">
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<Sales />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/sales" element={<Sales />} />
          <Route path="/draft/*" element={<Navigate to={window.location.pathname.replace(/^\/draft/, "") || "/"} replace />} />
          <Route path="/" element={<DraftLayout />}>
            <Route index element={<DraftHome />} />
            <Route path="how-we-work" element={<HowWeWork />} />
            <Route path="about" element={<About />} />
            <Route path="apply" element={<Apply />} />
            <Route path="book" element={<Book />} />
            <Route path="not-yet" element={<NotYet />} />
            <Route path="terms-of-use" element={<LegalPage slug="terms-of-use" />} />
            <Route path="privacy-policy" element={<LegalPage slug="privacy-policy" />} />
            <Route path="messaging-terms" element={<LegalPage slug="messaging-terms" />} />
            <Route path="contact" element={<Contact />} />
            <Route path="case-studies" element={<Home />} />
            <Route path="case-studies/:slug" element={<CaseStudy />} />
            <Route path=":service" element={<ServicePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
